import { useCallback, useEffect } from 'react';

export enum ReceivedMessageAction {
  SET_THEME = 'set-theme',
  GO_BACK = 'go-back'
}

export const useMessageListener = <T = unknown>(
  mappedAction: Partial<Record<ReceivedMessageAction, (data: T) => void>>
) => {
  const getData = useCallback((event: MessageEvent) => {
    if (typeof event.data === 'string') {
      return JSON.parse(event.data) as T;
    }

    return event.data as T;
  }, []);

  useEffect(() => {
    const listenerAction = (event: MessageEvent) => {
      let data: T;

      try {
        data = getData(event);
      } catch {
        return;
      }

      const action = (data as Record<string, unknown>)?.action as ReceivedMessageAction;

      if (!action || !mappedAction[action]) {
        return;
      }

      mappedAction[action]?.(data);
    };

    window.addEventListener('message', listenerAction);

    return () => {
      window.removeEventListener('message', listenerAction);
    };
  }, [mappedAction, getData]);
};
